import ApiLandingEadstock from "@/services/apiLandingEadstock.service";
import {
  FETCH_PREVIEW_URL,
  SEND_CONTACT_EMAIL
} from "@/store/actions/actions.type";
import {
  FETCH_PREVIEW_URL_START,
  FETCH_PREVIEW_URL_END,
  SEND_CONTACT_EMAIL_START,
  SEND_CONTACT_EMAIL_END
} from "@/store/mutations/mutations.type";

/* const defaults = Object.freeze({
  site: {
    previewUrl: ""
  }
}); */

const state = {
  /* site: object.clone(defaults.site),
  siterOriginal: {}, */
  isFetchingPreviewUrl: false,
  isSendingContactEmail: false
};

const getters = {
  /* site(state) {
    return state.site;
  }, */
  isFetchingPreviewUrl(state) {
    return state.isFetchingPreviewUrl;
  },
  isSendingContactEmail(state) {
    return state.isSendingContactEmail;
  }
};

const actions = {
  [FETCH_PREVIEW_URL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_PREVIEW_URL_START);

      ApiLandingEadstock.post("preview-exemplo", params)
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(e => {
          reject("Erro ao recuperar preview");
        })
        .finally(() => {
          context.commit(FETCH_PREVIEW_URL_END);
        });
    });
  },
  [SEND_CONTACT_EMAIL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SEND_CONTACT_EMAIL_START);

      ApiLandingEadstock.post("contact", params)
        .then(response => {
          console.log(response);
          resolve(response);
        })
        .catch(e => {
          reject("Erro ao enviar email de contato");
        })
        .finally(() => {
          context.commit(SEND_CONTACT_EMAIL_END);
        });
    });
  }
};

const mutations = {
  [FETCH_PREVIEW_URL_START](state) {
    state.isFetchingPreviewUrl = true;
  },
  [FETCH_PREVIEW_URL_END](state) {
    state.isFetchingPreviewUrl = false;
  },
  [SEND_CONTACT_EMAIL_START](state) {
    state.isSendingContactEmail = true;
  },
  [SEND_CONTACT_EMAIL_END](state) {
    state.isSendingContactEmail = false;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
